export const TRANSLATIONS_ES_CHAT_TASKS_AND_PROFILE = {
  "tasks.process_document_a": "Procesar documento A",
  "tasks.extract_entities_a": "Extracción de entidades del documento A",
  "tasks.classify_document_b": "Clasificar documento B",
  "tasks.classify_b_desc": "Clasificación automática de documento B",
  "tasks.index_document_c": "Indexar documento C",
  "tasks.index_c_desc": "Indexación de documento C para búsqueda",
  "tasks.summarize_document_d": "Resumen documento D",
  "tasks.summarize_d_desc": "Generación de resumen automático",
  "chat.title": "Asistente de Documentos",
  "chat.grounding.evidence.aria": "Estado de evidencia",
  "chat.grounding.evidence.grounded": "Respaldado por documentos",
  "chat.grounding.evidence.partially_grounded": "Respaldo parcial",
  "chat.grounding.evidence.no_evidence": "Sin evidencia documental",
  "chat.grounding.evidence.validation_failed": "No se pudo validar la evidencia",
  "chat.grounding.evidence.retrieval_failed": "No se pudo recuperar evidencia",
  "chat.grounding.evidence.unknown": "Evidencia no determinada",
  // Advertencias (P2-1): `retrieval_failed` NO es `no_evidence` — no se recuperó nada por
  // un fallo, que no es lo mismo que no haber nada. Copys distintos a propósito.
  "chat.grounding.evidence.warning.partially_grounded": "Esta respuesta se apoya solo en parte de la evidencia disponible y puede estar incompleta. Revisa las fuentes antes de usar cifras o fechas.",
  "chat.grounding.evidence.warning.no_evidence": "No se recuperó ningún documento para esta pregunta: esta respuesta no está respaldada por tus documentos.",
  "chat.grounding.evidence.warning.validation_failed": "No se pudo validar que esta respuesta se corresponda con los documentos recuperados. Revisa las fuentes antes de usar cifras o fechas.",
  "chat.grounding.evidence.warning.retrieval_failed": "No se pudo recuperar la evidencia por un error del sistema. Esta respuesta no está respaldada por tus documentos; vuelve a intentarlo.",
  "chat.generation.proposal.generateHere": "Generar aquí",
  "chat.generation.enqueued": "Tu resumen está siendo procesado. Si quieres ver el avance, da clic aquí.",
  "chat.generation.viewProgress": "Ver en Documentos Generados",
  "chat.generation.forbidden": "Tu plan no permite generar resúmenes o alcanzaste la cuota.",
  "chat.generation.error": "No se pudo encolar la generación.",
  "chat.generation.proposal.button": "Generar resumen ejecutivo",
  "chat.generation.proposal.fallback": "Puedo generar un resumen ejecutivo con tus documentos. ¿Genero?",
  "chat.generation.generateSummary": "Generar Resumen",
  "chat.generation.defaultHint": "Genera un resumen ejecutivo de mis documentos",
  "chat.plus.menuLabel": "Acciones",
  "chat.plus.modeSection": "Tipo de búsqueda",
  "chat.generation.candidatesQuestion": "Encontré estos documentos para tu resumen. ¿Genero el resumen con ellos?",
  "chat.generation.proposal.confirm": "Sí, generar resumen",
  "chat.generation.proposal.adjust": "Ajustar en el asistente",
  "chat.generation.unnamedDoc": "Documento",
  "chat.generation.armedPlaceholder": "Describe el resumen que quieres generar…",
  "chat.generation.armedCancel": "Cancelar Generar Resumen",
  "chat.placeholder": "Escribe tu mensaje...",
  "chat.send": "Enviar",
  "chat.sources": "Fuentes",
  // `score` es similitud coseno del retrieval, no una medida de confianza en la respuesta.
  "chat.relevance": "Relevancia",
  "chat.error.unsupportedQuestion": "Lo siento, no entendí el tipo de pregunta. ¿Podrías darme más contexto o detalles?",
  "chat.error.unexpected": "Ocurrió un error inesperado.",
  "chat.error.unknownResponse": "Respuesta desconocida del sistema.",
  "chat.download": "Descargar",
  "chat.feedback": "¿Te fue útil esta respuesta?",
  "chat.yes": "Sí",
  "chat.no": "No",
  "chat.feedback_comment": "Agrega un comentario (opcional)",
  "chat.feedback_thanks": "¡Gracias por tu feedback!",
  "chat.clear": "Limpiar chat",
  "chat.show_details": "Ver detalles",
  "chat.hide_details": "Ocultar detalles",
  "chat.selected_source": "Fuente seleccionada",
  "chat.location": "Ubicación",
  "chat.chunk": "Fragmento",
  "chat.typing": "Escribiendo...",
  "chat.recover": "Recuperar chat",
  "chat.new_session": "Nueva sesión",
  "chat.close": "Cerrar chat",
  "chat.message_change_name_success":
    "Nombre del chat actualizado correctamente",
  "chat.search_type": "Tipo de búsqueda",
  "chat.search_type.light": "Ligera",
  "chat.search_type.default": "Default",
  "chat.search_type.medium": "Medio",
  "chat.search_type.strong": "Fuerte",
  "chat.input_placeholder": "Pregunta lo que quieras",
  "chat.edit_message": "Editar mensaje",
  "chat.edit": "Editar",
  "chat.copy_message": "Copiar mensaje",
  "chat.like_message": "Me gusta",
  "chat.dislike_message": "No me gusta",
  "chat.deselect_message": "Deseleccionar mensaje",
  "chat.copied": "Copiado",
  "chat.download_document": "Descargar documento",
  "chat.documents": "Documentos",
  "chat.document": "Documento",
  "chat.double_click_hint": "Doble clic para ver fuentes",
  "chat.click_to_read_source": "Clic para leer esta fuente",
  "chat.fragment_text": "Fragmento citado",
  "chat.star_rating_title": "{{count}} estrellas",
  "chat.downloaded": "Descargado",
  "chat.close_detail": "Cerrar detalle",
  "chat.session_name_empty_error": "El nombre no puede estar vacío.",
  "chat.session_untitled": "Sesión sin nombre",
  "chat.rename": "Renombrar",
  "chat.save": "Guardar",
  "chat.cancel": "Cancelar",
  "chat.no_previous_sessions": "No hay sesiones previas.",
  "tasks.pending": "Tareas pendientes",
  "tasks.processed": "Tareas procesadas",
  "tasks.created": "Tareas creadas",
  "tasks.processed_at": "Procesado en",
  "tasks.loading": "Cargando tareas...",
  "tasks.status": "Estado",
  "tasks.step": "Paso",
  "tasks.description": "Descripción",
  "tasks.created_by": "Creado por",
  "tasks.no_processed": "No hay tareas procesadas.",
  "tasks.filters": "Filtros",
  "tasks.filter_by_id": "Filtrar por ID de tarea",
  "tasks.filter_by_date": "Filtrar por fecha",
  "tasks.clear_filters": "Limpiar filtros",
  "tasks.no_pending": "No hay tareas pendientes.",
  "profile.name": "Nombre",
  "profile.email": "Correo electrónico",
  "profile.company": "Empresa",
  "profile.role": "Rol",
  "profile.title": "Perfil",
  "profile.section_personal": "Información personal",
  "profile.section_organization": "Organización",
  "profile.country": "País",
  "profile.country_select": "Selecciona un país",
  "profile.section_preferences": "Preferencias",
  "profile.email_managed": "Correo gestionado por el sistema",
  "profile.role_managed": "Rol gestionado por el sistema",
  "profile.job_title": "Puesto de trabajo",
  "profile.organization_type": "Tipo de organización",
  "profile.organization_size": "Tamaño de la organización",
  "profile.loading": "Cargando perfil...",
  "profile.loading_data": "Cargando datos del perfil...",
  "profile.save": "Guardar Perfil",
  "profile.save_success": "Perfil guardado exitosamente",
  "chat.inputmode_question": "Obtener información del documento",
  "chat.inputmode_csv": "Consulta CSV",
  "chat.inputmode_db": "Consulta Base de Datos",
  "chat.inputmode_count_documents": "Conteo de Documentos",
  "chat.no_sessions": "No hay sesiones",
  "chat.tools": "Herramientas",
  "chat.expertRole.label": "Responder como…",
  "chat.expertRole.placeholder": "Sin rol",
  "chat.expertRole.clear": "Quitar experto",
  "chat.expertRole.applied": "Respondido como",
  "chat.expertRole.notEntitled": "Tu plan no incluye roles expertos",
  "chat.expertRole.degraded": "El rol seleccionado no se aplicó a esta respuesta.",
  "chat.expertRole.messageBadge": "Consulta con experto",
  "profile.change_photo": "Cambiar foto",
  "profile.name_required": "El nombre es obligatorio.",
  "profile.load_error": "Error al cargar el perfil.",
  "profile.photo_upload_error": "Error al subir la foto.",
  "profile.save_error": "Error al guardar el perfil.",
  "tasks.filter_by_status": "Filtrar por estado",
  "tasks.filter_by_user": "Filtrar por usuario",
  "tasks.filter_by_description": "Filtrar por descripción",
};
